import styled from "styled-components";

export const FilePreviewContainer = styled.div`
    display: flex;
    overflow-x: auto;
    gap: 1rem;
    padding: 1rem;
    width: 100%;
    background: #fff !important
`